/**
 * Created by r4zi4l on 06.07.2021
 */

const UnitsShopComponent = function (unit) {
    UnitComponent.call(this, unit);

    this.updateTab();

    if (cleverapps.environment.isAdministratorScene()) {
        return;
    }

    this.assignProduct();

    const shop = cleverapps.unitsShop.tabs[this.tab];
    shop.on("stateChanged", this.assignProduct.bind(this), this);

    cleverapps.eventBus.on("unitOpened", (unit) => this.onUnitOpened(unit), this);

    cleverapps.missionManager.on("add", (mission) => this.onMissionUpdate(mission), this);
    cleverapps.missionManager.on("complete", (mission) => this.onMissionUpdate(mission), this);
};

UnitsShopComponent.prototype = Object.create(UnitComponent.prototype);
UnitsShopComponent.prototype.constructor = UnitsShopComponent;

UnitsShopComponent.prototype.onUnitOpened = function (unit) {
    if (unit instanceof Unit) {
        if (unit.getType() === "resource" && this.unit.code === "discountshop") {
            this.assignProduct();
        }

        if (unit.getType() === "unitsshop") {
            cleverapps.toolbar.resetByType(ToolbarItem.UNIT_SHOP);
        }
    }
};

UnitsShopComponent.prototype.onMissionUpdate = function () {
    this.checkPrizes();
    this.checkCrystals();
};

UnitsShopComponent.prototype.onShowCrystals = function () {
    if (this.view) {
        this.view.showCrystals();
    }
};

UnitsShopComponent.prototype.onHideCrystals = function () {
    if (this.view) {
        this.view.hideCrystals();
    }
};

UnitsShopComponent.prototype.updateTab = function () {
    const data = this.unit.getData();

    const vip = cleverapps.vipAdsAdapter.getVIPStatus();

    if (data.vip_tab && vip.status) {
        this.tab = data.vip_tab;
    } else {
        this.tab = data.tab;
    }

    if (typeof this.tab === "object") {
        this.tab = this.tab[cleverapps.meta.selectedLocationId()];
    }
};

UnitsShopComponent.prototype.isCinema = function () {
    return this.tab === ShopWindow.TABS.UNITS_ADS || this.tab === ShopWindow.TABS.UNITS_ADS_VIP;
};

UnitsShopComponent.prototype.assignProduct = function () {
    if (this.unit.getData().toyfactory) {
        return;
    }

    const shop = cleverapps.unitsShop.tabs[this.tab];
    let product = shop.getFreeProduct();

    if (product) {
        product = product.unit;
    } else if (shop.fresh) {
        if (!this.isCinema() || connector.ads.isRewardedSupported) {
            product = {
                sprite: bundles.merge.frames.prize_exclamation
            };
        }
    }

    if (Unit.Equals(product && product[0], this.product && this.product[0])) {
        return;
    }

    this.product = product;
    this.unit.setPrizes(product);

    this.checkPrizes();
};

UnitsShopComponent.prototype.checkPrizes = function () {
    if (!this.product) {
        if (this.isCrystalsAvailable()) {
            this.unit.setPrizes({ sprite: bundles.merge.frames.bp_crystal_png });
        } else {
            this.unit.setPrizes();
        }
    }
};

UnitsShopComponent.prototype.hasCrystals = function () {
    const mission = cleverapps.missionManager.findByType(Mission.TYPE_SALEPASS);
    return mission && MissionManager.hasProperLocation(mission.type) && this.isCrystalsAvailable();
};

UnitsShopComponent.prototype.checkCrystals = function () {
    if (this.hasCrystals()) {
        this.onShowCrystals();
    } else {
        this.onHideCrystals();
    }
};

UnitsShopComponent.prototype.unitWithSalePass = function () {
    return this.unit.code === "discountshop";
};

UnitsShopComponent.prototype.isCrystalsAvailable = function () {
    const mission = cleverapps.missionManager.findByType(Mission.TYPE_SALEPASS);
    return mission && mission.isRunning() && MissionManager.hasProperLocation(mission.type) && !mission.logic.isAllTasksCompleted() && this.unitWithSalePass();
};

UnitsShopComponent.prototype.handlePrizes = function () {
    this.updateTab();

    const shops = cleverapps.unitsShop.getAvailableShops();
    if (shops.every((shop) => shop.tab !== this.tab)) {
        return true;
    }

    cleverapps.focusManager.display({
        stack: !cleverapps.focusManager.currentWindow() && (Map2dLocation.currentLocation.tutorial.checkConditions({ unit: this.unit }) || cleverapps.tutorial.checkConditions({ unit: this.unit })),
        focus: `displayUnitsShopComponent${this.tab}`,
        control: ["MenuBarGoldItem", "MenuBarCoinsItem"],
        actions: [
            (f) => {
                new UnitsShopWindow({ tab: this.tab });
                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                const cart = cleverapps.persist.acceptNode("UnitsShopCart");
                if (cart) {
                    cart.processItems(f);
                } else {
                    f();
                }
            }
        ]
    });

    return true;
};

UnitsShopComponent.prototype.handleClick = function () {
    this.handlePrizes();
    this.unit.squeeze();
    return true;
};

UnitsShopComponent.prototype.destructor = function () {
    runCleaners(this);
};
